import { Component, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { DwComponent, DwComponentType, DwDataFormatService, DwFormatTypes, DwMediaRepositoryService, DwMenuService, DwMetaDataListCardConfigData, DwMetaDataService, DwMetaDataServiceToken, DwRoutingService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';
import { DateTimeUtilService } from '../../../../shared/util/date-time-util.service';
import { CourseStudentProgressCardComponent } from '../course-student-progress-card/course-student-progress-card.component';


@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Course Card - Student Progress New',
  key: 'courseCard-StudentProgressNew',
  componentType: DwComponentType.card,
  //configComponent: DwCardDefaultConfigComponent,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Student,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-course-student-progress-card-new',
  templateUrl: './course-student-progress-card-new.component.html',
  styleUrls: ['./course-student-progress-card-new.component.scss']
})
export class CourseStudentProgressCardNewComponent extends CourseStudentProgressCardComponent implements OnChanges {

  // Computed properties for display
  imageUrl: string;
  backupImageUrl: string = '/assets/aviator-online/img/course-image-default.png';
  startedFormatted: string;
  lastActivityFormatted: string;
  timeSpentFormatted: string;

  constructor(
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwRoutingService: DwRoutingService,
    dateTimeUtilService: DateTimeUtilService,
    dwMenuService: DwMenuService,
    private dwDataFormatService: DwDataFormatService,
    private dwMediaRepository: DwMediaRepositoryService,
    @Inject(DwUIMetaDataConfigToken) private uiMetaDataConfig: DwUIMetaDataConfig
  ) {
    super(dwMetaDataService, dwRoutingService, dateTimeUtilService, dwMenuService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.data) {
      this.computeDerivedFields();
    }
    
  }

  setupCard(): void {
      super.setupCard();

      this.computeDerivedFields();
      
  }

  private computeDerivedFields(): void {
    if (!this.data) {
      return;
    }

    // Compute image URL from media path
    if (this.data.CourseImageDwroMediaMediaPath) {
      this.imageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(
        this.data.CourseImageDwroMediaMediaPath,
        250,
        141
      );
    } else {
      this.imageUrl = null;
    }

    // Format dates
    if (this.data.StudentCourseFirstActivityDateTime) {
      this.startedFormatted = 'Started: ' + this.dwDataFormatService.formatValue(
        this.data.StudentCourseFirstActivityDateTime,
        { formatType: DwFormatTypes.date, missingDataText: '', useGmtDateTime: this.uiMetaDataConfig.useGmtDateTime }
      );
    } else {
      this.startedFormatted = '';
    }

    if (this.data.StudentCourseLastActivityDateTime) {
      this.lastActivityFormatted = 'Last Activity: ' + this.dwDataFormatService.formatValue(
        this.data.StudentCourseLastActivityDateTime,
        { formatType: DwFormatTypes.date, missingDataText: '', useGmtDateTime: this.uiMetaDataConfig.useGmtDateTime }
      );
    } else {
      this.lastActivityFormatted = '';
    }

    // Format duration
    if (this.data.StudentCourseTotalTimeSeconds) {
      this.timeSpentFormatted = 'Time Spent: ' + this.dateTimeUtilService.formatDuration(this.data.StudentCourseTotalTimeSeconds);
    } else {
      this.timeSpentFormatted = '';
    }
  }

}
